const t = "{{currentTime}} de {{duration}}", e = "Resultat de cerca {{current}} de {{total}}", n = "No s'ha trobat cap resultat", o = "S'ha trobat {{count}} resultat", c = "S'han trobat {{count}} resultats", s = 'S’està reproduint des de $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) i $t(SECONDS, { "count": {{seconds}} }).', a = 'S’està reproduint des de , $t(MINUTES, { "count": {{minutes}} }) i $t(SECONDS, { "count": {{seconds}} }).', A = 'S’està reproduint des de $t(SECONDS, { "count": {{seconds}} }).', i = "S’ha produït un error en desar els canvis a l’expedient acadèmic.", E = "Línia d’expedient acadèmic a {{time}}. El contingut és: {{text}}.", T = 'Contenidor de línies d’expedients acadèmics. N’hi ha $t(TRANSCRIPT_LINES, { "count": {{count}} }) en aquest contenidor. Per navegar per l’interior d’aquest contenidor, feu servir la tecla avall.', S = "S’estan desant els canvis…", u = "S’han desat els canvis a l’expedient acadèmic.", _ = "En aquest moment, el botó Actualitza els subtítols està disponible.", r = "Acció", l = "Afegiu una anotació a les {{time}}", d = "Afegiu una pregunta a les {{time}}", R = "Anotacions", N = "Automàtic", I = "Automàtic ({{quality}})", O = "Enrere", C = "Subtítols", P = "Idioma dels subtítols", U = "Gestiona els subtítols", m = "Suprimeix {{language}}", p = "Mida del tipus de lletra", L = "Idioma dels subtítols: {{language}}", D = "{{language}} (automàtic)", M = "Esborreu la cerca", x = "Tanca", G = "Comentaris", Y = "Continua", g = "Redueix la velocitat de reproducció", h = "Redueix el volum en un {{percent}}%", b = "Fletxa cap avall", V = "Tanqueu l’editor d’expedients acadèmics", v = "Actualitzeu els subtítols", H = "Error.", F = "S'està desant…", B = "Desat.", K = "Editeu l’expedient acadèmic", f = "El text no pot estar buit", Q = "Pantalla completa", W = "{{count}} hora", $ = "{{count}} hores", q = "Augmenta la velocitat de reproducció", J = "Augmenta el volum en un {{percent}}%", z = "Inverteix els colors", Z = "Ves a un percentatge concret (1-10 %, 2-20 %, etc.)", X = "Ves a Inici", y = "Accions per a {{title}}", j = "Dreceres del teclat", k = "Idioma", w = "Fletxa esquerra", tt = "Menú principal", et = "{{count}} minut", nt = "{{count}} minuts", ot = "Silenci", ct = "En silenci", st = "Idioma del subtítol següent", at = "Proper resultat de la cerca", At = "Desactivat", it = "A dalt de tot", Et = "Obriu una anotació a les {{time}}", Tt = "Obriu una prova finalitzada a les {{time}}", St = "Obriu una prova a les {{time}}", ut = "Posa-ho en pausa", _t = "Reprodueix-ho", rt = "Velocitat de reproducció", lt = "Velocitat de reproducció: {{speed}}x", dt = "Idioma del subtítol anterior", Rt = "Anterior resultat de la cerca", Nt = "Qualitat", It = "Menú Qualitat", Ot = "Repeteix", Ct = "Restableix la velocitat de reproducció", Pt = "Fletxa dreta", Ut = "Feu una cerca a l’expedient acadèmic", mt = "{{count}} segon", pt = "{{count}} segons", Lt = "Cerca cap enrere: {{seconds}} segons", Dt = "Cerca endavant: {{seconds}} segons", Mt = "Configuració", xt = "Drecera", Gt = "Dades i eines dels elements multimèdia", Yt = "Espai", gt = "Menú Velocitat de reproducció", ht = "Inicieu el desplaçament automàtic", bt = "Commuta els subtítols", Vt = "Commuta la funció En silenci", vt = "Commuta la funció Reproducció / En pausa", Ht = "hi ha {{count}} línia d’expedient acadèmic", Ft = "hi ha {{count}} línies d’expedients acadèmics", Bt = "S’està carregant l’expedient acadèmic…", Kt = "No hem pogut carregar l’expedient acadèmic.", ft = "Opcions de l’expedient acadèmic", Qt = "Torna a provar-ho", Wt = "L’expedient acadèmic no està disponible", $t = "Fletxa amunt", qt = "Configuració de vídeo", Jt = "Volum", zt = "Volum: {{volume}}%", Zt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: e,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: o,
  A11Y_SEARCH_RESULTS_FOUND_other: c,
  A11Y_TIMESTAMP_JUMP_HOURS: s,
  A11Y_TIMESTAMP_JUMP_MINUTES: a,
  A11Y_TIMESTAMP_JUMP_SECONDS: A,
  A11Y_TRANSCRIPT_ERROR: i,
  A11Y_TRANSCRIPT_LINE: E,
  A11Y_TRANSCRIPT_LINES: T,
  A11Y_TRANSCRIPT_SAVING: S,
  A11Y_TRANSCRIPT_SUCCESS: u,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: _,
  ACTION: r,
  ADD_ANNOTATION_AT: l,
  ADD_QUESTION_AT: d,
  ANNOTATIONS: R,
  AUTO: N,
  AUTO_QUALITY: I,
  BACK: O,
  CAPTIONS: C,
  CAPTIONS_LANGUAGE: P,
  CAPTIONS_MANAGE: U,
  CAPTION_DELETE: m,
  CAPTION_FONT_SIZE: p,
  CAPTION_LANGUAGE: L,
  CAPTION_LANGUAGE_AUTOMATIC: D,
  CLEAR_SEARCH: M,
  CLOSE: x,
  COMMENTS: G,
  CONTINUE: Y,
  DECREASE_PLAYBACK_SPEED: g,
  DECREASE_VOLUME: h,
  DOWN_ARROW: b,
  EDIT_CLOSE: V,
  EDIT_CONFIRM: v,
  EDIT_ERROR: H,
  EDIT_SAVING: F,
  EDIT_SUCCESS: B,
  EDIT_TRANSCRIPT: K,
  EDIT_VALIDATION_ERROR: f,
  FULLSCREEN: Q,
  HOURS: W,
  HOURS_other: $,
  INCREASE_PLAYBACK_SPEED: q,
  INCREASE_VOLUME: J,
  INVERT_COLORS: z,
  JUMP_TO_PERCENTAGE: Z,
  JUMP_TO_START: X,
  KEBAB_MENU: y,
  KEYBOARD_SHORTCUTS: j,
  LANGUAGE: k,
  LEFT_ARROW: w,
  MAIN_MENU: tt,
  MINUTES: et,
  MINUTES_other: nt,
  MUTE: ot,
  MUTED: ct,
  NEXT_CAPTION_LANGUAGE: st,
  NEXT_HIT: at,
  OFF: At,
  ON_TOP: it,
  OPEN_ANNOTATION_AT: Et,
  OPEN_COMPLETED_QUIZ_AT: Tt,
  OPEN_QUIZ_AT: St,
  PAUSE: ut,
  PLAY: _t,
  PLAYBACK_SPEED: rt,
  PLAYBACK_SPEED_MESSAGE: lt,
  PREVIOUS_CAPTION_LANGUAGE: dt,
  PREVIOUS_HIT: Rt,
  QUALITY: Nt,
  QUALITY_MENU: It,
  REPLAY: Ot,
  RESET_PLAYBACK_SPEED: Ct,
  RIGHT_ARROW: Pt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Ut,
  SECONDS: mt,
  SECONDS_other: pt,
  SEEK_BACKWARD: Lt,
  SEEK_FORWARD: Dt,
  SETTINGS: Mt,
  SHORTCUT: xt,
  SIDEBAR: Gt,
  SPACE: Yt,
  SPEED_MENU: gt,
  START_AUTOSCROLL: ht,
  TOGGLE_CAPTIONS: bt,
  TOGGLE_MUTED: Vt,
  TOGGLE_PLAY_PAUSE: vt,
  TRANSCRIPT_LINES: Ht,
  TRANSCRIPT_LINES_other: Ft,
  TRANSCRIPT_LOADING: Bt,
  TRANSCRIPT_LOAD_ERROR: Kt,
  TRANSCRIPT_OPTIONS: ft,
  TRANSCRIPT_RETRY: Qt,
  TRANSCRIPT_UNAVAILABLE: Wt,
  UP_ARROW: $t,
  VIDEO_SETTINGS: qt,
  VOLUME: Jt,
  VOLUME_VALUE: zt
};
export {
  t as A11Y_DURATION,
  e as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  o as A11Y_SEARCH_RESULTS_FOUND,
  c as A11Y_SEARCH_RESULTS_FOUND_other,
  s as A11Y_TIMESTAMP_JUMP_HOURS,
  a as A11Y_TIMESTAMP_JUMP_MINUTES,
  A as A11Y_TIMESTAMP_JUMP_SECONDS,
  i as A11Y_TRANSCRIPT_ERROR,
  E as A11Y_TRANSCRIPT_LINE,
  T as A11Y_TRANSCRIPT_LINES,
  S as A11Y_TRANSCRIPT_SAVING,
  u as A11Y_TRANSCRIPT_SUCCESS,
  _ as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  r as ACTION,
  l as ADD_ANNOTATION_AT,
  d as ADD_QUESTION_AT,
  R as ANNOTATIONS,
  N as AUTO,
  I as AUTO_QUALITY,
  O as BACK,
  C as CAPTIONS,
  P as CAPTIONS_LANGUAGE,
  U as CAPTIONS_MANAGE,
  m as CAPTION_DELETE,
  p as CAPTION_FONT_SIZE,
  L as CAPTION_LANGUAGE,
  D as CAPTION_LANGUAGE_AUTOMATIC,
  M as CLEAR_SEARCH,
  x as CLOSE,
  G as COMMENTS,
  Y as CONTINUE,
  g as DECREASE_PLAYBACK_SPEED,
  h as DECREASE_VOLUME,
  b as DOWN_ARROW,
  V as EDIT_CLOSE,
  v as EDIT_CONFIRM,
  H as EDIT_ERROR,
  F as EDIT_SAVING,
  B as EDIT_SUCCESS,
  K as EDIT_TRANSCRIPT,
  f as EDIT_VALIDATION_ERROR,
  Q as FULLSCREEN,
  W as HOURS,
  $ as HOURS_other,
  q as INCREASE_PLAYBACK_SPEED,
  J as INCREASE_VOLUME,
  z as INVERT_COLORS,
  Z as JUMP_TO_PERCENTAGE,
  X as JUMP_TO_START,
  y as KEBAB_MENU,
  j as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  w as LEFT_ARROW,
  tt as MAIN_MENU,
  et as MINUTES,
  nt as MINUTES_other,
  ot as MUTE,
  ct as MUTED,
  st as NEXT_CAPTION_LANGUAGE,
  at as NEXT_HIT,
  At as OFF,
  it as ON_TOP,
  Et as OPEN_ANNOTATION_AT,
  Tt as OPEN_COMPLETED_QUIZ_AT,
  St as OPEN_QUIZ_AT,
  ut as PAUSE,
  _t as PLAY,
  rt as PLAYBACK_SPEED,
  lt as PLAYBACK_SPEED_MESSAGE,
  dt as PREVIOUS_CAPTION_LANGUAGE,
  Rt as PREVIOUS_HIT,
  Nt as QUALITY,
  It as QUALITY_MENU,
  Ot as REPLAY,
  Ct as RESET_PLAYBACK_SPEED,
  Pt as RIGHT_ARROW,
  Ut as SEARCH_TRANSCRIPT_PLACEHOLDER,
  mt as SECONDS,
  pt as SECONDS_other,
  Lt as SEEK_BACKWARD,
  Dt as SEEK_FORWARD,
  Mt as SETTINGS,
  xt as SHORTCUT,
  Gt as SIDEBAR,
  Yt as SPACE,
  gt as SPEED_MENU,
  ht as START_AUTOSCROLL,
  bt as TOGGLE_CAPTIONS,
  Vt as TOGGLE_MUTED,
  vt as TOGGLE_PLAY_PAUSE,
  Ht as TRANSCRIPT_LINES,
  Ft as TRANSCRIPT_LINES_other,
  Bt as TRANSCRIPT_LOADING,
  Kt as TRANSCRIPT_LOAD_ERROR,
  ft as TRANSCRIPT_OPTIONS,
  Qt as TRANSCRIPT_RETRY,
  Wt as TRANSCRIPT_UNAVAILABLE,
  $t as UP_ARROW,
  qt as VIDEO_SETTINGS,
  Jt as VOLUME,
  zt as VOLUME_VALUE,
  Zt as default
};
